"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var LinkCopier_1 = __importDefault(require("atomicComponents/organisms/LinkCopier"));
var Subject = function (_a) {
    var _b;
    var vendor = _a.vendor;
    return (0, jsx_runtime_1.jsx)(LinkCopier_1.default, { text: (_b = end2end_1.SUBJECT_SEARCH_VENDOR_MAPPER[vendor]) !== null && _b !== void 0 ? _b : '' });
};
exports.default = Subject;
